import React, { useEffect, useState } from 'react';

import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

const getButtonClasses = (isActive) => {
  return isActive ? 'opacity-0 group-hover:opacity-100' : 'hidden';
};

export const TableHeaderComponent = (props) => {
  const { displayName, column, api, setSort, enableSorting } = props;
  const currentSort = column.getSort();
  const [columnWidth, setColumnWidth] = useState(() => column.getActualWidth() || 0);

  const onSortAsc = () => setSort('asc', false);
  const onSortDesc = () => setSort('desc', false);
  const onSortNone = () => setSort(null, false);

  useEffect(() => {
    if (!api) {
      const width = column.getActualWidth();
      if (width) setColumnWidth(width);
      return;
    }

    const columnId = column.getColId();

    const updateWidth = () => {
      const width = column.getActualWidth();
      if (width) {
        setColumnWidth((prevWidth) => {
          return width !== prevWidth ? width : prevWidth;
        });
      }
    };

    const onColumnResized = (event) => {
      if (!event.columns || event.columns.some((col) => col.getColId() === columnId)) {
        updateWidth();
      }
    };

    const onColumnMoved = () => {
      updateWidth();
    };

    const onColumnVisible = () => {
      updateWidth();
    };

    api.addEventListener('columnResized', onColumnResized);
    api.addEventListener('columnMoved', onColumnMoved);
    api.addEventListener('columnVisible', onColumnVisible);

    updateWidth();

    return () => {
      api.removeEventListener('columnResized', onColumnResized);
      api.removeEventListener('columnMoved', onColumnMoved);
      api.removeEventListener('columnVisible', onColumnVisible);
    };
  }, [api, column]);

  return (
    <div
      className="group flex w-full cursor-pointer items-center justify-between gap-1"
      onClick={(e) => e.stopPropagation()}>
      <Typography
        variant="p"
        size="small"
        weight="semibold"
        className="block min-w-0 truncate"
        style={columnWidth > 0 ? { maxWidth: `${columnWidth - 50}px` } : undefined}>
        {displayName}
      </Typography>
      {enableSorting && (
        <>
          <Button
            icon="order-newest-first-linear"
            variant="link"
            size="sm"
            onClick={onSortAsc}
            color="neutral"
            iconShade={700}
            iconSize={12}
            tooltip="A-Z"
            className="bg-neutral-75 p-1.5"
            wrapperClassName={getButtonClasses(!currentSort)}
          />
          <Button
            icon="order-oldest-first-linear"
            variant="link"
            size="sm"
            onClick={onSortDesc}
            color="neutral"
            iconShade={700}
            iconSize={12}
            tooltip="Z-A"
            className="bg-neutral-75 p-1.5"
            wrapperClassName={getButtonClasses(currentSort === 'asc')}
          />
          <Button
            icon="arrow-swap-down-linear"
            variant="link"
            size="sm"
            onClick={onSortNone}
            color="neutral"
            iconShade={700}
            iconSize={12}
            tooltip="Manual"
            className="bg-neutral-75 p-1.5"
            wrapperClassName={getButtonClasses(currentSort === 'desc')}
          />
        </>
      )}
    </div>
  );
};
